import { useJWTUser } from 'contexts/JWTContext';
import { Navigate, useLocation } from 'react-router-dom';
import React, { useMemo } from 'react';
import { IsUserInRole } from 'models/jwt/identity';

type Props = {
    adminOnly?: boolean,
    children: JSX.Element
};

const RequireAuth = ({ adminOnly, children }: Props) => {
  const user = useJWTUser();
  const location = useLocation();
  const isAdmin = useMemo(() => user && IsUserInRole(user, 'Admin'), [user]);
  console.log(isAdmin);
  // Check if user is authenticated and optionally, if adminOnly is set, if user is admin
  if (!user || (adminOnly && !IsUserInRole(user, 'Admin'))) {
    // Redirect to login page
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};
export default RequireAuth;
